<template>
<div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header p-3">
          <h6 class="modal-title">{{$t('Tag Face(s)')}}</h6>
          <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" @click="closeModall">
            <span aria-hidden="true"><close-icon class="close-icon" style="height: 30px !important;
    width: 30px !important;
    color: #fff;"></close-icon></span>
          </button>
        </div>
        <div class="modal-body personality-dropdown-wrapper">
            <Multiselect
                v-model="selectedPersonalityMapper"
                :options="personalitiesList"
                :multiple="true"
                :searchable="true"
                :close-on-select="true"
                :allow-empty="false"
                label="display_name"
                deselectLabel=""
                selectLabel=""
                selectedLabel=""
                track-by="_id"
                :placeholder="$t('Select Personality')"
                @select="onPersonalityChange($event)"
                @search-change="getusersOnKeyup($event)"
                @open="getusersOnKeyup()"
                @remove="personalityOnRemove($event)"
               
                >
                <!-- style="pointer-events:none" -->
                <span slot="noResult">No results</span>
                <span slot="noOptions" style="display:none"></span>
                <div slot="tag" slot-scope="option" class="selected-tags-style">
                    <div v-if="Object.keys(option.option).includes('profile_image') && !['undefined',null].includes(option.option.profile_image) && option.option.profile_image" class='user-name-or-image'>
                        <img :src="getProxyConvertedImage(option.option.profile_image)" @error="replaceWithUserIcon($event,option.option.display_name)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px;margin-bottom: 5px">
                    </div>
                    <template v-else>
                        <div v-if="option.option.display_name.toLowerCase().includes('+ create new')" class="user-name-or-image" :style="style(option.option.nadisplay_nameme)"> + </div>
                        <div v-else class="user-name-or-image" :style="style(option.option.display_name)">{{ option.option.display_name.split("")[0] }}</div>
                    </template>
                    <div style="display: inline-flex;align-items: center;margin-inline-start: 10px;">
                        <div class="tags-display-style">{{option.option.display_name}}</div>
                        <div class="remove-tag" v-on:click="personalityOnRemove(option.option)">
                            <svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                            </svg>
                        </div>
                    </div>
                </div>
                <div style="display:flex;max-height:12px;align-items:center;width: fit-content;" class="checkbox-label" slot="option" slot-scope="scope">
                    <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makeIncludeLabelsCheckBoxSelection(scope.option)" @focus.prevent :key="scope.option.display_name"/>
                    <div v-if="Object.keys(scope.option).includes('profile_image') && !['undefined',null].includes(scope.option.profile_image) && scope.option.profile_image" class='user-name-or-image'>
                        <img :src="getProxyConvertedImage(scope.option.profile_image)" @error="replaceWithUserIcon($event,scope.option.display_name)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px;margin-bottom: 5px">
                    </div>
                    <template v-else>
                        <div v-if="scope.option.display_name.toLowerCase().includes('+ create new')" class="user-name-or-image" :style="style(scope.option.display_name)">+</div>
                        <div v-else class="user-name-or-image" :style="style(scope.option.display_name)">{{ scope.option.display_name.split("")[0] }}</div>
                    </template>
                    <span style="margin-inline-start:12px;">{{ scope.option.display_name }}</span>
                </div>
            </Multiselect>
        </div>
        <div class="modal-footer p-0 primary-btn-style">
          <button class="btn btn-outline-secondary mr-3" data-dismiss="modal" @click="closeModall">{{$t('Cancel')}}</button>
          <button class="btn btn-outline-primary mr-2"  @click.prevent="addPersonalities()">{{$t('Add')}}</button> <!--"-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>


import {mapActions} from "vuex";
import Multiselect from "vue-multiselect";
import Utils from "../../components.utils.js";
import Constants from "../../components.constants.js";
import closeIcon from "../core/InlineCancelField.vue";

export default {
    props:[""],
    data(){
        return{
            selectedPersonalityMapper : [],
            aaa:{},
            personalitiesList:[],
        }
    },
    components:{
        Multiselect,
        "close-icon":closeIcon,
    },
   methods:{
    getProxyConvertedImage(image_url){
        return Utils.convertToLoginIPDomainName(image_url);
    },
    style(name){
        let style = {
            'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
            'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
        }
        return style
    },
    replaceWithUserIcon(e){
        e.target.onerror = null
        e.target.src = Utils.getNoThumbnailImg();
    },
    async onPersonalityChange(option){
        if(option.display_name.toLowerCase().includes("+ create new")){
            let emptyName = true
            if(option.display_name.length > 0){
                let stringWithQuotes = option.display_name;
                // Remove double quotes using the replace() method
                let stringWithoutQuotes = stringWithQuotes.replace(/"/g, '');

                // Remove the "(+ create new)" part using substring()
                let finalString = stringWithoutQuotes.substring(0, stringWithoutQuotes.indexOf('(+ create new)'));

                let personalityName = finalString.trim();
                if(personalityName.length > 0){
                    emptyName = false;
                    let payload = {name: personalityName, profile_image: null, file_uids: [], alias:[]};
                    let data = await this.addNewPersonalityFromServer(payload);
                    if (Constants.acceptedStatusCodes.includes(data.statusCode)){
                        let profileData = {
                            name : data.upserted_data.name,
                            display_name: data.upserted_data.name,
                            alias: [],
                            _id : data.upserted_data._id,
                            profile_image : data.upserted_data.profile_image,
                            file_uids : data.upserted_data.file_uids
                        }

                        let profileIndx = this.selectedPersonalityMapper.findIndex((obj)=>obj._id == data.upserted_data._id);
                        if(profileIndx < 0){
                            this.selectedPersonalityMapper.push(profileData);
                        }
                    }else{
                        if('message' in data){
                            this.$toast.error(data.message);
                        }else{
                            this.$toast.error("Unable to create new personality. ");
                        }
                    }
                }
            }
            if(emptyName){
                alert("Personality with empty is not allowed.")
            }
            this.selectedPersonalityMapper = this.selectedPersonalityMapper.filter((obj)=>obj._id != '0001')
            return false;
        }
    },
    getusersOnKeyup(option){
        let payload = {params:{limit: 50}};
        if(option && typeof(option) != "undefined" && option.trim().length > 0){
            payload['name'] = option.trim();
            payload.params['alias'] = JSON.stringify([option.trim()]);
        }
        this.getPersonalitiesListByServer(payload).then((data)=>{
            this.personalitiesList = data.personalities;
            if('name' in payload && payload['name'].trim().length > 0){
                let indx = data.personalities.findIndex((obj)=>obj.display_name.trim().toLowerCase() == payload['name'].trim().toLowerCase()); 
                if(indx < 0){
                    this.personalitiesList.unshift({"display_name":`"${payload['name'].trim()}" (+ create new)`, "_id":"0001"});
                }    
            }
        })
    },
    closeModall(){
        this.$emit("closeTagFaceModal", true);
    },

    makeIncludeLabelsCheckBoxSelection(option){
        if(this.selectedPersonalityMapper){
            return this.selectedPersonalityMapper.some((op) => op._id === option._id);
        }else{
            return false
        }
    },
    removeSelectedIncludeLabel(){

    },
    personalityOnRemove(option){
        this.selectedPersonalityMapper = this.selectedPersonalityMapper.filter(e => e._id != option._id)
    },
    addPersonalities(){
        if(this.selectedPersonalityMapper && this.selectedPersonalityMapper.length > 0){
            this.$emit("browsedPersonalities", this.selectedPersonalityMapper);
        }else{
            alert("Please choose personalities.")
        }
    },
    ...mapActions("faceDetection", ["getPersonalitiesListByServer", "addNewPersonalityFromServer"]),
   }
}
</script>

<style lang="scss" scoped>
    $table-row-border: none;
    $active-blue: #007bff;
    $danger-color: #dc3545;
    $none-text-color:#4f4f4f;
    $add-button-text-color:#0b7099;
    $add-button-text-color-hover:#0193cc;
    $add-button-border-color:#b7b228;
    $add-button-border-on-hover:#dcd426;
    $add-button-backgroud:#1e1e1e;
    $active-green-color:#28a745;
    $primary-background: #1a1e21;
    $border-color: 1px solid #4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $highlight-font-color:#ff9800;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555; 
    $input-field-padding:.375rem 10px;
    $filter-border-color: #5a5a5a;
    $filter-bg-color: #2a2a2a;
    $learn-about-text-color-hover:#b7b327;
    $learn-about-text-color:#9a9620;
    $tags-background-color:#282d31;
    $svg-color:#666;
    $tags-border-color:#363636;
    $secondary-border-color: 1px solid #2b2b2b;
    $icon-hover:#2c3339;

    .tags-display-style{
        color: #c3c3c3;
    }

    .selected-tags-style{
        background: $tags-background-color;
        border: 1px solid $tags-border-color;
        border-radius: 15px;
        font-size: 12px !important;
        min-height: 25px !important;
        display: inline-flex !important;
        margin: 2px !important;
        border-radius: 15px !important;
        min-width: 50px !important;
        padding: 0px !important;
        text-align: center;
        width: auto !important;
        padding-inline-start: 12px !important;
        justify-content: center;
        padding-top: 4px !important;
        padding-inline-end: 12px !important;
        margin-top:8px !important;
        .remove-tag{
          line-height:18px;
          color: #757575;
        }
      }

    .modal-dialog {
        max-width: 600px;
        width: 600px;
        margin: 0;
        padding: 0;
    }

    .modal{
        transition: opacity .3s ease;
    }

    
    .modal-content {
        height: auto;
        min-height: 100%;
        border: 0 none;
        border-radius: 0;
        box-shadow: none;
        background: $primary-background !important;
        border: $secondary-border-color;
        .modal-body{
            background: $primary-background;
            padding: 2rem;
        }
    }

    .modal {
        text-align: center;
        padding: 0 !important;
        display: block;
        position: fixed;
        inset-inline-start: 0px;
        top: 20% !important;
    }
    .modal-header .close {
        margin: -1rem -13px -1rem auto !important;
    }
    .modal:before {
    content: '';
        display: inline-block;
        height: 100vh;
        vertical-align: middle;
        margin-inline-end: -4px;
        position: fixed;
        width: 100vw;
        inset-inline-start: 0;
        top: 0;
        background: #00000094;
    }
    .modal-dialog {
    display: inline-block;
    text-align: start;
    vertical-align: middle;
    }

    .btn{
        font-size:$input-field-and-label-font-size !important;
        height:100%;
    }

    .border{
        border: $border-color !important;
    }

    .modal-header,.modal-footer{
        border-top: $secondary-border-color !important;
        border-bottom: $secondary-border-color !important;
        background: $secondary-background-color;
        height: 58px;
        .modal-title{
        color:$text-color;
        }
    }
    .modal-header .close {
        margin: -1rem -13px -1rem auto !important;
    }

    .primary-btn-style{
        button{
            height: 35px;
            width: 70px;
            font-size:$input-field-and-label-font-size;
        }
    }

    .secondary-btn-style{
    color:$text-color;
    }

    .key-style {
    color: $dull-text-color;
    width: 30%;
    text-align: start;
    font-size: $input-field-and-label-font-size;
    padding-inline-start: 5px;
    padding-inline-end: 5px;
    margin-top: 3px;
    }

    .close-icon:hover{
    background: $icon-hover;
    border-radius: 20px;
    }

    .bigger-checkboxes {
        height: 30px;
        width: 20px;
        position:relative;
    }
    input[type="checkbox"]:after {
        line-height: 1.5em;
        content: "";
        display: inline-block !important;
        width: 22px !important;
        height: 21px !important;
        margin-top: 5px !important;
        margin-inline-start: -1px !important;
        border: $border-color !important;
        border-radius: 0.25em !important;
        background: $primary-background !important;
    }
    input[type="checkbox"]:checked:after {
        content: "✔";
        color: $active-blue !important;
        position: absolute !important;
        font-size: 16px !important;
        line-height: 1 !important;
        transition: all 0.2s !important;
        font-family: Helvetica, Arial, sans-serif;
        padding-inline-start: 4px !important;
        padding-top: 2px !important;
    }

    .user-name-or-image{
        height: 30px;
        width: 30px;
        border: $border-color;
        border-radius: 10px;
        text-align: center;
        line-height: 28px;
        text-transform: uppercase;
        margin-top: 3px;
    }

    .tags-style{
        display: flex;
        height: fit-content;
        padding: 5px;
        width: auto;
        border-radius: 11px;
        margin-inline-end:0px 5px;
        .user-name-display{
            line-height: 33px;
            padding-inline-start: 5px;
        }
        .remove-tag{
            line-height: 32px;
            position: relative;
            inset-inline-start: 5px;
            svg{
                height:30px !important;
            }
        }
    }

   ::v-deep{
    .add-search-filter{
        display: inline-flex;
        border: 1px solid #0779fb !important;
        color: #0779fb !important;
        .add-fileds-icon{
            position: absolute;
            inset-inline-start: 10px;
            z-index: 99;
            top: 13px;
        }
        .multiselect{
            min-width:15%;
            margin: -2px 0px;
            .multiselect__tag{
                display:none;
            }
            .multiselect__select{
                display:none;
            }
        }
    }
    .multiselect{
            width:100%;
            margin: 3px 0px;
    }
    .multiselect__content-wrapper{
        display:none;
    }
    .multiselect__tag, .tags-style {
        background-color: $primary-background !important;
        border: $border-color;
        border-radius: 5px;
        margin-bottom:0px;
    }
    .tags-style {
        background: $primary-background !important;
        border: $border-color !important;
    }
        .multiselect__option--highlight {
            background: $bg-color-on-hover !important;
        }
        .multiselect__content {
            background: $secondary-background-color !important;
        }
        .multiselect__input, .multiselect__single {
            background: transparent !important;
            color:$text-color;
        }
        .multiselect__input:focus{
            outline:none;
            box-shadow: none;
        }
        .multiselect__tag-icon{
        color:$text-color;
        }
        .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
            background: $bg-color-on-hover !important;
            color: $text-color !important;
        }
        .multiselect__tag-icon:after{
        color:$secondary-text-color !important;
        font-size: 20px;
        }
        .multiselect *{
            font-size: $input-field-and-label-font-size;
            font-family: "Roboto", Arial, sans-serif !important;
        }
        .multiselect__tags{
            display: block;
            align-items: center;
        }
        .multiselect__placeholder {
            padding-top: 5px !important;
            margin-bottom:0px;
            color:#5d5d5d !important;
        }
        .multiselect{
            color:$text-color !important;
            font-size: $input-field-and-label-font-size !important;
            min-height: 38px;
        }
        .multiselect__single{
            padding-top:6px !important;
        }
        .multiselect__option--selected{
            background: $bg-color-on-hover !important;
            color: $text-color;
        }
        .multiselect__content-wrapper{
            border: 1px solid $bg-color-on-hover !important;
            position: absolute;
            display: block;
            background: $text-color;
            width: 100%;
            max-height: 150px;
            overflow: auto;
            border: 1px solid $text-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
        }
        .multiselect__select,.multiselect__current,.multiselect__option{
            line-height: 12px !important;
        }
        .multiselect--above .multiselect__content-wrapper{
        background: $secondary-background-color !important;
        }
        .multiselect__tags {
            background: transparent !important;
            height: auto !important;
            padding: 8px 40px 8px 8px !important;
            border: $border-color !important;
        }
        .personality-dropdown-wrapper .multiselect__content{
            width:100% !important;
            .multiselect__option {
                white-space: normal !important;
                line-height:20px !important;
            }
        }
        .filter-wrapper{
            display:inline-flex;
            align-items: center;
            border: $border-color;
            border-radius: 5px;
            background: $primary-background;
            color:$dull-text-color;
            .filter-label{
                margin:0px 4px;
                width: auto;
                white-space: nowrap;
            }
            .comm-input-field-style,.multiselect__tags{
                border: none !important;
                border-radius: none !important;
            }
            .mx-input{
                height:38px;
            }
            .multiselect{
                margin:0px !important;
            }
        }
    }


</style>
